import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.split.js";
import _defineProperty from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import chooseTime from "./chooseTime";
import { fetchList } from "@/api/PMS/placeManage/placeManage";
import { fetchDict } from "@/api/MLXC/countryServe/partyManage";
import { fetchCreate, fetchUpdate, fetchDetail, fetchCompanyList } from "@/api/PMS/longTermReservation/longTermReservation";
export default {
  props: ["keyValue", "showDialog"],
  components: {
    chooseTime: chooseTime
  },
  data: function data() {
    return {
      rules: _defineProperty({
        companyId: [{
          required: true,
          message: "请选择单位",
          trigger: "change"
        }],
        periodName: [{
          required: true,
          message: "请输入订场名称",
          trigger: "blur"
        }, {
          min: 1,
          max: 100,
          message: "长度在 1 到 100 个字符",
          trigger: "change"
        }],
        startTime: [{
          required: true,
          message: "请选择长期订场开始日期",
          trigger: "change"
        }],
        endTime: [{
          required: true,
          message: "请选择长期订场结束日期",
          trigger: "change"
        }],
        week: [{
          required: true,
          message: "请选择订场时间",
          trigger: "change"
        }],
        placeIdsList: [{
          required: true,
          message: "请选择场地",
          trigger: "change"
        }]
      }, "periodName", [{
        required: true,
        message: "请选择时间段",
        trigger: "change"
      }]),
      childData: {},
      companyList: [],
      statusOptions: [],
      placeOptions: [],
      periodIdList: [],
      dialogFormVisible: false,
      areaId: "",
      selected: [],
      selectedAreaId: null
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.selectedAreaId = null;
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    changePlace: function changePlace(values) {
      var _this = this;

      var selectedAreas = values.map(function (value) {
        return _this.placeOptions.find(function (option) {
          return option.id === value;
        }).areaId;
      });
      this.selectedAreaId = selectedAreas[0];
      this.$set(this.childData, "periodName", "");
      this.$set(this.childData, "periodId", "");
    },
    choosePlace: function choosePlace() {
      if (this.childData.placeIdsList && this.childData.placeIdsList.length > 0) {
        this.areaId = this.selectedAreaId;

        if (this.childData.periodId) {
          var newArr = this.childData.periodId.split(",").map(function (item) {
            return Number(item);
          });
          this.periodIdList = newArr;
        } else {
          this.periodIdList = [];
        }

        this.dialogFormVisible = true;
      } else {
        this.Alert({
          alertType: "error",
          message: "请选择场地"
        });
      }
    },
    shouldDisable: function shouldDisable(areaId) {
      // 如果已经有选择且类型不同，则禁用
      if (this.selectedAreaId && areaId !== this.selectedAreaId) {
        return true;
      }

      return false;
    },
    handCreateTime: function handCreateTime(data) {
      var periodName = "";
      periodName = data.map(function (row) {
        return "".concat(row.startTime, "-").concat(row.endTime);
      }).join(",");
      var periodId = "";
      periodId = data.map(function (row) {
        return "".concat(row.id);
      }).join(",");
      this.$set(this.childData, "periodName", periodName);
      this.$set(this.childData, "periodId", periodId); // this.childData.bookStartPeriod = data.startTime;
      // this.childData.bookEndPeriod = data.endTime;
      // this.childData.price = data.price;

      this.dialogFormVisible = false;
    },
    handCancleTime: function handCancleTime() {
      this.dialogFormVisible = false;
    },
    getPlace: function getPlace() {
      var _this2 = this;

      fetchList({}).then(function (res) {
        _this2.placeOptions = res.data.data;
      });
    },
    getType: function getType() {
      var _this3 = this;

      fetchDict({
        dicType: "week_date"
      }).then(function (res) {
        _this3.statusOptions = res.data.data;
      });
    },
    getCompany: function getCompany() {
      var _this4 = this;

      fetchCompanyList({}).then(function (res) {
        _this4.companyList = res.data.data;
      });
    },
    init: function init() {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.$refs["dataForm"].clearValidate();
      });
      this.getPlace();
      this.getType();
      this.getCompany();

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this5.childData = response.data.data;
          _this5.childData.week = _this5.childData.week.toString();
        });
      } else {
        this.childData = {
          priceName: ""
        };
      }
    },
    handCreate: function handCreate() {
      var _this6 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          if (_this6.childData.startTime > _this6.childData.endTime) {
            _this6.Alert({
              alertType: "error",
              message: "长期订场开始日期不能大于长期订场结束日期"
            });

            return;
          }

          if (_this6.childData.periodName == undefined || _this6.childData.periodName == "" || _this6.childData.periodName == null) {
            _this6.Alert({
              alertType: "error",
              message: "请选择时间段"
            });

            return;
          } // if (
          //   this.childData.bookStartPeriod == undefined ||
          //   this.childData.bookStartPeriod == "" ||
          //   this.childData.bookStartPeriod == null
          // ) {
          //   this.Alert({ alertType: "error", message: "请选择订场时间段" });
          //   return;
          // }
          // if (
          //   this.childData.bookEndPeriod == undefined ||
          //   this.childData.bookEndPeriod == "" ||
          //   this.childData.bookEndPeriod == null
          // ) {
          //   this.Alert({ alertType: "error", message: "请选择订场时间段" });
          //   return;
          // }


          var str = _this6.childData.placeIdsList.join(",");

          _this6.$set(_this6.childData, "placeIds", str);

          if (_this6.keyValue > 0) {
            fetchUpdate(_this6.childData).then(function (res) {
              if (res.data.code == 200) {
                _this6.$emit("handCancle", true);

                _this6.Alert({
                  alertType: "update"
                });
              }
            });
          } else {
            fetchCreate(_this6.childData).then(function (res) {
              if (res.data.code == 200) {
                _this6.$emit("handCancle", true);

                _this6.Alert({
                  alertType: "add"
                });
              }
            });
          }
        } else {
          _this6.Alert({
            alertType: "valid"
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit("handCancle", false);
    }
  }
};